const config = {
    dev: {
        TITLE: "Pharmarack Retailer DEV",
        BASE_URL: "https://pharmretail-modernization-dev-api.pharmarack.com/",
        CMS_URL: "https://pharmretail-modernization-dev-cmsgateway.pharmarack.com/",
        OPEN_SEARCH: "https://pharmretail-modernization-dev-elasticsearch.pharmarack.com/",
        REACT_APP_NPCI_BASE_URL: "https://pharmretail-payment-api.ragabh.com/",
        SEARCH_VERSION: "v1",
        MAIN_VERSION: "v1",
        CMS_VERSION: "v1",
        halfSchemeRegion: ["Hyderabad", "Jaipur"],
        timeout: 90000,
        pharmretaile_1_0: "https://ragabh.com/account/login",
    },
    uat: {
        TITLE: "Pharmarack Retailer UAT",
        BASE_URL: "https://pharmretail-modernization-uat-api.ragabh.com/",
        CMS_URL: "https://pharmretail-modernization-uat-cmsgateway.ragabh.com/",
        OPEN_SEARCH: "https://pharmretail-modernization-uat-elasticsearch.ragabh.com/",
        REACT_APP_NPCI_BASE_URL: "https://pharmretail-payment-api.ragabh.com/",
        SEARCH_VERSION: "v1",
        MAIN_VERSION: "v3",
        CMS_VERSION: "v1",
        halfSchemeRegion: ["Hyderabad", "Jaipur"],
        timeout: 120000,
        pharmretaile_1_0: "https://ragabh.com/account/login",
    },
    prod: {
        TITLE: "Pharmarack Retailer",
        BASE_URL: "https://pharmretail-api.pharmarack.com/",
        CMS_URL: "https://pharmretail-cmsgateway.pharmarack.com/",
        OPEN_SEARCH: "https://pharmretail-elasticsearch.pharmarack.com/",
        REACT_APP_NPCI_BASE_URL: "https://pharmretail-payment-api.pharmarack.com/",
        SEARCH_VERSION: "v1",
        MAIN_VERSION: "v3",
        CMS_VERSION: "v1",
        halfSchemeRegion: ["Hyderabad", "Jaipur"],
        timeout: 90000,
        pharmretaile_1_0: "https://www.pharmarack.com/account/login",
    },
    local: {
        TITLE: "Pharmarack Retailer Local",
        BASE_URL: "http://192.168.50.132:3000/",
        REACT_APP_NPCI_BASE_URL: "https://pharmretail-payment-api.ragabh.com/",
        CMS_URL: "https://pharmretail-modernization-dev-cmsgateway.pharmarack.com/",
        OPEN_SEARCH: "https://pharmretail-modernization-dev-elasticsearch.pharmarack.com/",
        SEARCH_VERSION: "v1",
        MAIN_VERSION: "v3",
        CMS_VERSION: "v1",
        halfSchemeRegion: ["Hyderabad", "Jaipur"],
        timeout: 120000,
        pharmretaile_1_0: "https://ragabh.com/account/login",
    },
};

const env = process.env.REACT_APP_ENV || 'dev';  // Default to 'dev' if not set
const currentConfig = config[env];

export default currentConfig;
